<template>
    <el-dialog
      :visible.sync="followOnDialog.show"
      :append-to-body='true'
      width="600px"
      :modal='true'
      class="followOnDialog"
      >
      <div class="content">
        <div>{{ $t("lang.followOnselectTitle") }}</div>
        <div class="select">
          <el-radio v-model="followOnType" :label="0">{{ $t("lang.onlySelectedEvent") }}</el-radio>
          <el-radio v-model="followOnType" :label="1">{{ $t("lang.allEventsFollow") }}({{getEndTime()}})</el-radio>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="followOnDialog.show = false">{{ $t("lang.cancel") }}</el-button>
        <el-button type="primary" @click="confirm"  :loading="followOnDialog.loading">{{ $t("lang.Confirm") }}</el-button>
      </span>
    </el-dialog>
</template>

<script>
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    followOnDialog: {
      type: Object,
      default: () => {
        return {
          show: false
          // fillType: 1
        }
      }
    }
  },
  data () {
    return {
      followOnType: 0
    }
  },
  methods: {
    confirm () {
      this.$emit('followOnSelect', this.followOnType)
      this.followOnDialog.show = false
    },
    // 时间转换
    getEndTime () {
      return Outil.TransitionCurrentTime1(new Date(this.followOnDialog.endTime))
    }
  }
}
</script>

<style lang='less' scoped >
  .followOnDialog{
    ::v-deep .el-dialog{
        .el-dialog__header{
          height: 48px;
          line-height: 48px;
          border: none;
        }
        .el-dialog__body{
          padding: 10px 20px;
          .content{
            text-align: left;
            .select{
              padding-top: 10px;
              .el-radio{
                display: block;
                padding-bottom: 5px;
                .el-radio__label{
                  color: #DBDBDB;
                }
              }
            }

          }
        }
        .el-dialog__footer{
          padding: 24px 0;
          button{
            padding: 10px 16px;
          }
        }
      }
    }
</style>
